/*
 * Portions of this code are from Novel (https://github.com/steven-tey/novel)
 * Copyright (c) 2023 Steven Tey
 * Licensed under the Apache License, Version 2.0
 */

// import Magic from '@/components/editor/icons/magic'
// import { Button } from '@blogging/ui'
import { EditorBubble, useEditor } from '@/components/tiptap-editor'
import { removeAIHighlight } from '@/components/tiptap-editor/extensions'
import { Fragment, type ReactNode, useEffect } from 'react'
import { AISelector } from './ai-selector'

interface GenerativeMenuSwitchProps {
  children: ReactNode
  open: boolean
  onOpenChange: (open: boolean) => void
}
const GenerativeMenuSwitch = ({
  children,
  open,
  onOpenChange,
}: GenerativeMenuSwitchProps) => {
  const { editor } = useEditor()

  useEffect(() => {
    if (!open && editor) removeAIHighlight(editor)
  }, [open, editor])

  return (
    <EditorBubble
      tippyOptions={{
        placement: open ? 'bottom-start' : 'top',
        onHidden: () => {
          onOpenChange(false)
          if (editor) editor.chain().unsetHighlight().run()
        },
      }}
      pluginKey="generative-menu"
      element={document.createElement('div')}
    >
      <div className="flex w-fit max-w-[90vw] overflow-hidden rounded-md border border-muted bg-background shadow-xl">
        {open && <AISelector open={open} onOpenChange={onOpenChange} />}
        {!open && (
          <Fragment>
            {/* <Button
            className="gap-1 rounded-none text-purple-500"
            variant="ghost"
            onClick={() => onOpenChange(true)}
            size="sm"
          >
            <Magic className="h-5 w-5" />
            Ask AI
          </Button> */}
            {children}
          </Fragment>
        )}
      </div>
    </EditorBubble>
  )
}

export default GenerativeMenuSwitch
